export const truncateHtmlByWords = (html: string, wordLimit: number): { truncated: string; isTruncated: boolean } => {
    const textContent = html
        .replace(/<[^>]+>/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
    const words = textContent.split(' ')

    if (words.length <= wordLimit) {
        return { truncated: html, isTruncated: false }
    }

    let truncatedHtml = ''
    let wordCount = 0

    const htmlRegex = /<[^>]+>|[^<]+/g
    let match

    while ((match = htmlRegex.exec(html)) !== null && wordCount < wordLimit) {
        const segment = match[0]

        if (segment.startsWith('<')) {
            truncatedHtml += segment
        } else {
            const segmentWords = segment
                .trim()
                .split(/\s+/)
                .filter((word) => word.length > 0)
            const remainingWords = wordLimit - wordCount

            if (segmentWords.length <= remainingWords) {
                truncatedHtml += segment
                wordCount += segmentWords.length
            } else {
                truncatedHtml += segmentWords.slice(0, remainingWords).join(' ')
                wordCount = wordLimit
                break
            }
        }
    }

    if (truncatedHtml.includes('<p') && !truncatedHtml.includes('</p>')) {
        truncatedHtml += '</p>'
    }

    return { truncated: truncatedHtml, isTruncated: true }
}
